import React from 'react'
import { C, fOutfit, fBody, fMono, PublicNav, PublicFooter } from '../../../Shared/Brand'
import { Icon } from '../../../Shared/Icons'

const AREAS = [
  { icon: 'bot', title: 'Engineering', desc: 'Building and maintaining the arbitrage engine, exchange integrations, and trading dashboard.' },
  { icon: 'shield', title: 'Risk & Compliance', desc: 'Keeping trading conditions, disclosures, and regulatory registrations accurate as we grow.' },
  { icon: 'headset', title: 'Support', desc: 'Helping traders get the most out of their account and resolving issues quickly.' },
]

export default function Careers() {
  return (
    <div style={{ background: C.white, color: C.tx, fontFamily: fBody, minHeight: '100vh' }}>
      <style>{`
        .xcr-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 24px; }
      `}</style>
      <PublicNav active="Company" />

      <section style={{ padding: '130px 24px 60px', textAlign: 'center', background: C.dark, color: C.ltx, borderBottom: `1px solid ${C.dbdr}` }}>
        <div style={{ fontSize: '11px', fontFamily: fMono, letterSpacing: '0.14em', color: C.primary, textTransform: 'uppercase', marginBottom: '10px' }}>Company</div>
        <h1 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(32px,5vw,48px)', lineHeight: 1.1, margin: '0 0 14px' }}>Careers</h1>
        <p style={{ fontSize: '16px', fontWeight: 500, color: C.ltx2, maxWidth: '560px', margin: '0 auto' }}>We're a small, focused team building automated trading infrastructure. There are no open roles listed right now, but we're always glad to hear from people who want to help build this.</p>
      </section>

      <section style={{ padding: '64px 24px', maxWidth: '1000px', margin: '0 auto' }}>
        <h2 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(26px,3.5vw,34px)', lineHeight: 1.1, textAlign: 'center', margin: '0 0 40px', color: C.tx }}>Where We're Growing</h2>
        <div className="xcr-grid">
          {AREAS.map(a => (
            <div key={a.title} style={{ textAlign: 'center' }}>
              <div style={{ color: C.primary, display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
                <Icon name={a.icon} size={36} strokeWidth={1.5} />
              </div>
              <div style={{ fontFamily: fOutfit, fontWeight: 600, fontSize: '18px', color: C.tx, marginBottom: '8px' }}>{a.title}</div>
              <p style={{ fontSize: '14px', color: C.tx2, lineHeight: 1.6, margin: 0 }}>{a.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section style={{ padding: '64px 24px', borderTop: `1px solid ${C.bdr}`, background: C.light, textAlign: 'center' }}>
        <div style={{ fontSize: '14px', fontWeight: 500, color: C.tx3 }}>No open positions at this time — check back soon.</div>
      </section>

      <PublicFooter />
    </div>
  )
}
